import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import * as api from 'core/api';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountUnsubscribeComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    view = 'loading';

    email: string | null = null;
    subscriptions: api.Subscription[] = [];
    selectedSubscriptionIds: number[] = [];

    unsubscriptionModal = {
        view: 'loading'
    }

    mounted() {
        this.email = <string>this.$route.query.email || null;
        this.loadModel();
    }

    loadModel() {
        if (this.email) {
            new api.BestPriceService().getSubscriptions({ email: this.email }).then(
                (result) => {
                    this.subscriptions = result.subscriptions;
    
                    this.view = 'view';
                },
                (error) => {
                    if (error.response) {
                        console.log('XHR failed', error.response.status, error.response.data);
                    } else {
                        console.log('XHR error', error.message);
                    }
                }
            );
        }
    }

    formatDate(date: Date) {
        return moment(date).format('DD.MM.YY');
    }

    unsubscribe() {
        this.unsubscriptionModal.view = 'loading';
        (<any>this.$refs).modalUnsubscription.show();

        new api.BestPriceService().unsubscribe({
            email: this.email!,
            subscriptionIds: this.selectedSubscriptionIds
        }).then(
            () => {
                this.selectedSubscriptionIds = [];
                this.unsubscriptionModal.view = 'success';
                this.loadModel();
            },
            (error) => {
                this.unsubscriptionModal.view = 'error';

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
}
